// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3azo9","name":"styles_name__HkVwM","detail":"styles_detail___nipy","title":"styles_title__KwqeN"};